export const extensionArray: any[] = ['PDF', 'DWF', 'DWFX', 'ENB', 'BLG', 'TXT', 'PNG', 'JPG', 'CVS', 'DOC', 'XML', 'DOCX', 'XLS', 'XLSX', 'GIF']

export const extensionOption = [
    {
        value: '.pdf',
        label: '.pdf',
        isDefault: false,
    },
    {
        value: '.dwf',
        label: '.dwf',
        isDefault: false,
    },
    {
        value: '.enb',
        label: '.enb',
        isDefault: false,
    },
    {
        value: '.blg',
        label: '.blg',
        isDefault: false,
    },
    {
        value: '.txt',
        label: '.txt',
        isDefault: false,
    },
    {
        value: '.png',
        label: '.png',
        isDefault: false,
    },
    {
        value: '.jpg',
        label: '.jpg',
        isDefault: false,
    },
    {
        value: '.cvs',
        label: '.cvs',
        isDefault: false,
    },
    {
        value: '.doc',
        label: '.doc',
        isDefault: false,
    },
    {
        value: '.docx',
        label: '.docx',
        isDefault: false,
    },
    {
        value: '.xls',
        label: '.xls',
        isDefault: false,
    },
    {
        value: '.xlsx',
        label: '.xlsx',
        isDefault: false,
    },
    {
        value: '.gif',
        label: '.gif',
        isDefault: false,
    },
];